function prefersFallbackShell() {
  const coarse = window.matchMedia?.('(pointer: coarse)').matches;
  const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const narrow = window.innerWidth <= 760;
  const lowMemory = (navigator.deviceMemory || 4) <= 2;
  return reduced || narrow || lowMemory || (coarse && window.innerWidth < 920);
}

window.CODEX_PRE_TIER = prefersFallbackShell() ? 'fallback' : 'full';
document.documentElement.dataset.preTier = window.CODEX_PRE_TIER;

function showBootFallback(error) {
  console.error(error);
  document.getElementById('loadingOverlay')?.classList.add('done');
  const center = document.getElementById('centerArea');
  if (!center || document.getElementById('fallbackNexus')) return;
  const shell = document.createElement('div');
  shell.id = 'fallbackNexus';
  shell.className = 'fallback-nexus';
  shell.innerHTML = `<div class="fallback-hero">
    <div class="fallback-title">CODEX LITE NEXUS</div>
    <div class="fallback-copy">The full visual engine could not start here, so the Codex has opened a lightweight chamber. Refresh, or use desktop for the full cube nexus.</div>
  </div>`;
  center.appendChild(shell);
}

if (window.CODEX_PRE_TIER === 'fallback') {
  import('./app.js').catch(showBootFallback);
} else {
  import('three')
    .then(THREE => {
      window.THREE = THREE;
      return import('./app.js');
    })
    .catch(() => {
      window.CODEX_PRE_TIER = 'fallback';
      document.documentElement.dataset.preTier = 'fallback';
      return import('./app.js');
    })
    .catch(showBootFallback);
}
